import { CLOSE_QUOTE_FORM, NEW_QUOTE_REQUEST } from "../actions/quoteAction";

const initialState = {
    isShow: false,
    loading: false,
    error: '',
    data: {},
    common: {
        carTypes: [],
        carType: {},
        companyVehicleTypes: []
    }
};

const quote = (state = initialState, action) => {
    switch (action.type) {
        case NEW_QUOTE_REQUEST:
            return {
                ...state,
                isShow: true
            };
        case CLOSE_QUOTE_FORM:
            return initialState;
        default:
            return state
    }
}

export default quote